import styled from 'styled-components';

const Heading = styled.h1`
	letter-spacing: 8px;
	font-size: 4rem;
	color: var(--very-light-gray);
`;

export default Heading;
